export function canShareFiles(files: File[] = []): boolean {
    if (typeof navigator === 'undefined') return false

    // Нет поддержки API
    if (typeof navigator.share !== 'function') return false

    // Если браузер не поддерживает canShare — считаем, что файлы нельзя
    if (files.length > 0) {
        if (typeof navigator.canShare !== 'function') return false

        // Некоторые браузеры возвращают false даже для валидных файлов
        try {
            return navigator.canShare({ files })
        } catch {
            return false
        }
    }

    // Поддерживается хотя бы базовый share (без файлов)
    return true
}
